<div ng-cloak>
  
      <itec-form 
        name="ctrl.formulari.nom"
        fields="ctrl.formulari.camps"
        ng-model="ctrl.entitat"
        ng-submit-function="ctrl.formulari.func()"
        errors="ctrl.errors"
        backbutton="true"
        backbuttonfunction="ctrl.back()">
      </itec-form>
   
</div>